/** SSO 会话管理：浏览器只持 HttpOnly Session Cookie；本文件查会话、未登录跳统一登录页 */

let _user = null;

/** 获取当前登录用户（main.js 挂载前已通过 ensureSession 就绪） */
export function getSessionUser() {
  return _user;
}

/** 查询后端会话；未登录返回 null */
export async function fetchSession() {
  const res = await fetch('/auth/session', { credentials: 'include' });
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(`Session 获取失败: ${res.status}`);
  const data = await res.json();
  return data.user;
}

/** 确保已登录：未登录跳转统一登录页；已登录返回用户信息 */
export async function ensureSession() {
  const user = await fetchSession();
  if (!user) {
    redirectToLogin();
    return null;
  }
  _user = user;
  return user;
}

/** 跳统一登录页：return_to 带当前完整 URL（path+search+hash），登录后原样回跳 */
export function redirectToLogin() {
  const current = window.location.pathname + window.location.search + window.location.hash;
  window.location.assign(`/auth/login?return_to=${encodeURIComponent(current)}`);
}

/**
 * 401 兜底复核：单个请求 401 不代表会话真的失效（并发刷新 token、鉴权服务抖动都会给 401），
 * 先问一次 /auth/session 再决定要不要把整页跳到登录页。
 * 返回用户对象表示会话还在；null 表示确实失效；网络异常按「还在」处理，不误踢用户。
 */
export async function recheckSession() {
  try {
    const user = await fetchSession();
    if (user) _user = user;
    return user;
  } catch {
    return _user;
  }
}

/** 退出登录：SDK 清除本业务 Session，redirect_url 完成 Auth Service 全局退出 */
export async function logout() {
  const res = await fetch('/auth/logout', {
    method: 'POST',
    credentials: 'include',
  });
  const payload = await res.json();
  window.location.assign(payload.redirect_url);
}
